/**
 * Local Language Translations for the application.
 *
 * Base/Key of the language is kept as EN.
 */
module.exports = {
    "or": {
        'en': 'OR',
        'de': 'ODER',
        'fr': 'OU',
        'nl': 'OF'
    },
    "reservation": {
        'en': 'Reservation',
        'de': 'Reservierung',
        'fr': 'Reservation',
        'nl': 'Reservatie'
    },
    "leave_contact_details": {
        'en': 'Leave Contact Details',
        'de': 'Kontaktdaten hinterlassen',
        'fr': 'Laisser vos coordonnées',
        'nl': 'Contactgegevens achterlaten'
    },
    "full_name": {
        'en': 'Full Name',
        'de': 'Vollständiger Name',
        'fr': 'Nom complet',
        'nl': 'Voor-en achternaam'
    },
    "zip": {
        'en': 'Zip code',
        'de': 'Postleitzahl',
        'fr': 'le code postal',
        'nl': 'Postcode'
    },
    "city": {
        'en': 'City',
        'de': 'Stadt',
        'fr': 'une ville',
        'nl': 'Stad'
    },
    "country": {
        'en': 'Country',
        'de': 'Land',
        'fr': 'un pays',
        'nl': 'Land'
    },
    "address": {
        'en': 'address',
        'de': 'Adresse',
        'fr': 'adresse',
        'nl': 'adres'
    },
    "email": {
        'en': 'Email',
        'de': 'Email',
        'fr': 'Email',
        'nl': 'Email'
    },
    "phone": {
        'en': 'Phone Number',
        'de': 'Telefonnummer',
        'fr': 'Numéro de téléphone',
        'nl': 'Telefoonnummer'
    },
    "submit": {
        'en': 'Submit',
        'de': 'Einreichen',
        'fr': 'Soumettre',
        'nl': 'Verzenden'
    },
    "cancel": {
        'en': 'Cancel',
        'de': 'Abbrechen',
        'fr': 'Annuler',
        'nl': 'Annuleren'
    },
    "resubmit": {
        'en': 'Resubmit',
        'de': 'Erneut einreichen',
        'fr': 'Soumettre à nouveau',
        'nl': 'Opnieuw indienen'
    },
    "submitted_as": {
        'en': 'Submited as',
        'de': 'Eingereicht als',
        'fr': 'Soumis comme',
        'nl': 'Ingediend als'
    },
    "please_enter_valid_email": {
        'en': 'Please enter a valid email.',
        'de': 'Bitte geben Sie eine gültige Email-Adresse ein.',
        'fr': 'Veuillez saisir un e-mail valide.',
        'nl': 'Gelieve een geldig e-mailadres in te vullen.'
    },
    "marketing_consent_description": {
        'en': 'Keep me up to date with the latest info and special offers.',
        'de': 'Halten Sie mich mit auf dem Laufenden den neuesten Informationen und Sonderangeboten.',
        'fr': 'Tenez-moi au courant des dernières informations et offres.',
        'nl': 'Blijf up to date met onze laatste info en speciale acties.',
    },
    "data_deletion_message": {
        'en': "We automatically delete your data within 14 days, and won't use it for anything else then contact tracing in case of emergency.",
        'de': "Wir löschen Ihre Daten automatisch innerhalb von 14 Tagen und verwenden sie nicht für andere Zwecke als die Rückverfolgung im Notfall.",
        'fr': "Nous supprimons automatiquement vos données dans les 14 jours, et ne les utiliserons pas pour autre chose que le suivi des contacts en cas d'urgence.",
        'nl': "We verwijderen uw gegevens automatisch binnen 14 dagen en gebruiken ze niets anders dan contacttracering in geval van nood."
    },
    "add_to_cart": {
        'en': 'Add',
        'nl': 'Bestel',
        'de': 'Bestel',
        'fr': 'Ajoute'
    },
    'modifiers_for': {
        'en': 'Please make your selection for',
        'nl': 'Gelieve je selecties te maken',
        'de': 'Bitte auswählen für',
        'fr': 'Veuillez choisir vos options pour'
    },
    'go_to_cart': {
        'en': 'REVIEW ORDER',
        'nl': 'BEKIJK BESTELLING',
        'de': 'BESTELLUNG ÜBERPRÜFEN',
        'fr': 'FINALISER LA COMMANDE'
    },
    'items': {
        'en': 'items.',
        'nl': 'producten.',
        'de': 'produkte.',
        'fr': 'Articles.'
    },
    'quantity': {
        'en': 'Quantity',
        'nl': 'Aantal',
        'de': 'Mänge',
        'fr': 'Quantité'
    },
    'price': {
        'en': 'Price',
        'nl': 'Prijs',
        'de': 'Preis',
        'fr': 'Prix'
    },
    'total': {
        'en': 'Total',
        'nl': 'Totaal',
        'de': 'Summe',
        'fr': 'Total'
    },
    'proceed_to_checkout': {
        'en': 'Place Order',
        'nl': 'Bestelling plaatsen',
        'de': 'Bestellung aufgeben',
        'fr': 'Passer la commande'
    },
    'select_table': {
        'en': 'Select Table',
        'nl': 'Selecteer je tafel',
        'de': 'Wählen Sie Ihren Tisch',
        'fr': 'Selecter votre table'
    },
    'continue_to_payment': {
        'en': 'Proceed to Payment',
        'nl': 'Ga door naar betaling',
        'de': 'Weiter zur Zahlung',
        'fr': 'Procéder au paiement'
    },
    'your_cart': {
        'en': 'Your Order',
        'nl': 'Jouw bestelling',
        'de': 'Ihre Bestellung',
        'fr': 'Votre commande'
    },
    'note_label': {
        'en': "Add a note to your order",
        'fr': "Ajouter une note à votre commande",
        'nl': "Voeg een notitie toe aan uw bestelling",
        'de': "Fügen Sie Ihrer Bestellung eine Notiz hinzu"
    },
    'create_new_order': {
        'en': 'Create New Order',
        'fr': 'Créer une nouvelle commande',
        'nl': 'Start een nieuwe bestelling',
        'de': 'Neue Bestellung erstellen'
    },
    'take_away': {
        'en': 'Take Away',
        'fr': 'À emporter',
        'nl': 'Afhalen',
        'de': 'Take Away'
    },
    'order_details': {
        'en': 'Order Details',
        'fr': 'Résumé de votre commande',
        'nl': 'Bestelling',
        'de': 'Bestelldetails'
    },
    'retry_payment': {
        'en': 'Retry Payment',
        'fr': 'Réessayer le paiement',
        'nl': 'Probeer de betaling opnieuw',
        'de': 'Versuchen Sie die Zahlung erneut'
    },
    'minimum_one_item_is_required': {
        'en': 'Minimun one modifer needs to be selected.',
        'fr': "Un minimum d'un modificateur doit être sélectionné.",
        'nl': 'Er moet minimaal één optie worden geselecteerd.',
        'de': 'Es muss mindestens eine Option ausgewählt werden.'
    },
    'multiple_modifiers_can_be_selected': {
        'en': 'Multiple modifiers can be selected.',
        'fr': "Plusieurs modificateurs peuvent être sélectionnés.",
        'nl': 'Er kunnen meerdere opties worden geselecteerd.',
        'de': 'Es können mehrere Optionen ausgewählt werden.'
    },
    'only_one_modifier_allowed': {
        'en': 'Only one modifier is allowed.',
        'fr': "Un seul modificateur est autorisé.",
        'nl': 'Er is slechts één optie toegestaan.',
        'de': 'Es ist nur eine Option zulässig.'
    },
    'add_something_to_cart': {
        'en': 'Add items',
        'fr': "Ajouter des produits",
        'nl': 'Voeg items toe',
        'de': 'Etwas hinzufügen'
    },
    'order': {
        'en': 'Order',
        'fr': "Commande",
        'nl': 'Bestelling',
        'de': 'Bestellung'
    },
    'note': {
        'en': 'Note',
        'fr': "Remarque",
        'nl': 'Notitie',
        'de': 'Notiz'
    },
    'table': {
        'en': 'Table',
        'fr': "Table",
        'nl': 'Tafel',
        'de': 'Tisch'
    },
    'payment_still_processing': {
        'en': "We're still processing your payment, please wait a few seconds.",
        'fr': "Nous sommes toujours en train de traiter votre paiement, veuillez patienter quelques secondes.",
        'nl': 'Uw betaling wordt nog verwerkt. Wacht een paar seconden.',
        'de': 'Wir bearbeiten Ihre Zahlung noch. Bitte warten Sie einige Sekunden.'
    },
    'please_enter_security_code': {
        'en': 'Please Enter the Security Code.',
        'fr': "Entrez le code de sécurité s'il vous plaît.",
        'nl': 'Voer de beveiligingscode in.',
        'de': 'Bitte geben Sie den Sicherheitscode ein.'
    },
    'security_code': {
        'en': 'Security Code',
        'fr': "Code de sécurité",
        'nl': 'Beveiligingscode',
        'de': 'Sicherheitscode'
    },
    'valid_security_code': {
        'en': 'Yay! Security Code is correct.',
        'fr': "Yay! Le code de sécurité est correct.",
        'nl': 'Ja! Beveiligingscode is correct.',
        'de': 'Yay! Sicherheitscode ist korrekt.'
    },
    'invalid_security_code': {
        'en': 'Incorrect security code.',
        'fr': "Code de sécurité incorrect.",
        'nl': 'Verkeerde beveiligingscode.',
        'de': 'Falscher Sicherheitscode.'
    },
    'please_select_table': {
        'en': 'Please Select Table.',
        'fr': "Veuillez sélectionner la table.",
        'nl': 'Selecteer de tafel.',
        'de': 'Bitte wählen Sie Ihren Tisch.'
    },
    'something_went_wrong': {
        'en': 'Awtsch something went wrong!',
        'fr': "Ohla, quelque chose s'est mal passé!",
        'nl': 'Oei, er is iets fout gegaan!',
        'de': 'Etwas ist schief gelaufen!'
    },
    'select_time_slot': {
        'en': 'Select a time',
        'fr': "sélectionner une heure",
        'nl': 'Selecteer een tijd',
        'de': 'Wählen Sie eine Abholzeit'
    },
    'select_day': {
        'en': 'Select a day',
        'fr': "Sélectionner un jour",
        'nl': 'Selecteer een dag',
        'de': 'wählen einen Tag aus'
    },
    'no_time_slots': {
        'en': 'No time slots available',
        'fr': 'Sélectionner un jour',
        'nl': 'Geen tijdssloten beschikbaar',
        'de': 'Wähle einen Tag aus'
    },
    'meer_dagen': {
        'en': 'More days',
        'fr': 'Plus de jours',
        'nl': 'Meer dagen',
        'de': 'Mehr Tage'
    },
    'minder_dagen': {
        'en': 'Less days',
        'fr': 'Moins de jours',
        'nl': 'Minder dagen',
        'de': 'Weniger Tage'
    },
    'search_for_food': {
        'en': 'Search for food',
        'fr': 'Recherche de nourriture',
        'nl': 'Zoek naar eten',
        'de': 'Suche nach Nahrung'
    },
    'menu_Items': {
        'en': 'Menu items',
        'fr': 'Éléments du menu',
        'nl': 'Menu items',
        'de': 'Menüpunkte'
    },
    'select_items': {
        'en': 'Items',
        'fr': 'Les articles',
        'nl': 'Items',
        'de': 'Artikel'
    },
    'contact_details': {
        'en': 'Contact details',
        'fr': 'Détails du contact',
        'nl': 'Contact gegevens',
        'de': 'Kontaktdetails'
    },
    'payment': {
        'en': 'Pay',
        'fr': 'Payer',
        'nl': 'Betaal',
        'de': 'Zahlen'
    },
    '': {
        'en': '',
        'fr': '',
        'nl': '',
        'de': ''
    },
    'Home': {
        'en': 'Home',
        'fr': 'Accueil',
        'nl': 'Home',
        'de': 'Zuhause'
    },
    'Menu': {
        'en': 'Menu',
        'fr': 'Menu',
        'nl': 'Menu',
        'de': 'Speisekarte'
    },
    'Discount': {
        'en': 'Discount',
        'fr': 'Remise',
        'nl': 'Korting',
        'de': 'Rabatt'
    },
    'almond': {
        'en': 'almond',
        'fr': 'amande',
        'nl': 'amandel',
        'de': 'Mandel'
    },
    'soy': {
        'en': 'soy',
        'fr': 'soja',
        'nl': 'soja',
        'de': 'Soja'
    },
    'peanut': {
        'en': 'peanut',
        'fr': 'cacahuète',
        'nl': 'pinda',
        'de': 'Erdnuss'
    },
    'gluten': {
        'en': 'gluten',
        'fr': 'gluten',
        'nl': 'gluten',
        'de': 'Gluten'
    },
    'fish': {
        'en': 'fish',
        'fr': 'poisson',
        'nl': 'vis',
        'de': 'Fisch'
    },
    'milk': {
        'en': 'milk',
        'fr': 'lait',
        'nl': 'melk',
        'de': 'Milch'
    },
    'egg': {
        'en': 'egg',
        'fr': 'oeuf',
        'nl': 'ei',
        'de': 'Ei'
    },
    'meat': {
        'en': 'meat',
        'fr': 'viande',
        'nl': 'vlees',
        'de': 'Fleisch'
    },
    'vegetarian': {
        'en': 'vegetarian',
        'fr': 'végétarien',
        'nl': 'vegetarisch',
        'de': 'Vegetarier'
    },
    'vegan': {
        'en': 'vegan',
        'fr': 'végétalien',
        'nl': 'veganistisch',
        'de': 'Vegan'
    },
    'sugar_free': {
        'en': 'sugarfree',
        'fr': 'sans sucre',
        'nl': 'suikervrij',
        'de': 'Zuckerfrei'
    },
    'menu_category': {
        'en': 'Menu Category',
        'fr': 'Catégorie de menu',
        'nl': 'Menu categorie',
        'de': 'Menükategorie'
    },
    'my_order': {
        'en': 'My Order',
        'fr': 'Ma commande',
        'nl': 'Mijn bestelling',
        'de': 'Meine Bestellung'
    },
    'Time': {
        'en': 'Time',
        'fr': 'Temps',
        'nl': 'Tijdsslot',
        'de': 'Zeit'
    },
    'number_of_guests': {
        'en': 'Number of guests',
        'fr': "Nombre d'invités",
        'nl': 'Aantal gasten',
        'de': 'Anzahl der Gäste'
    },
    'fee': {
        'en': 'Servicekosten',
        'fr': 'Servicekosten',
        'nl': 'Servicekosten',
        'de': 'Servicekosten'
    },
    'tip': {
        'en': 'Tip',
        'fr': 'Tip',
        'nl': 'Tip',
        'de': 'Tip'
    },
    'min_order_Amount': {
        'en': 'Order at least above',
        'fr': 'Order at least above',
        'nl': 'Order at least above',
        'de': 'Order at least above'
    },
    'information': {
        'en': 'There is a minimum order amount for this menu ',
        'fr': 'Il y a un montant minimum de commande pour ce menu ',
        'nl': 'Voor dit menu geldt een minimum bestelbedrag van ',
        'de': 'Für dieses Menü gibt es einen Mindestbestellwert '
    },
    'information_extra': {
        'en': '. If you order less, there is a surcharge ',
        'fr': '. Si vous commandez moins, il y a un supplément ',
        'nl': '. Indien je minder bestelt geldt er een toeslag van ',
        'de': '. Wenn Sie weniger bestellen, fällt ein Aufpreis an '
    },
    'information_extra_extra': {
        'en': '. Order a little more to complete your order.',
        'fr': '. Commandez un peu plus pour terminer votre commande.',
        'nl': '. Bestel iets meer om je bestelling af te ronden.',
        'de': '. Bestellen Sie etwas mehr, um Ihre Bestellung abzuschließen.'
    },
    'Charges': {
        'en': 'Charges',
        'fr': 'Des charges',
        'nl': 'Toeslag',
        'de': 'Gebühren'
    },
    'go_back_to_your_order': {
        'en': 'Back to your order',
        'fr': 'Retourner à votre commande',
        'nl': 'Terug naar jouw bestelling',
        'de': 'zurück zu Ihrer Bestellung'
    },
    'completed': {
        'en': 'Your order is completed',
        'fr': 'Votre commande est terminée',
        'nl': 'Uw bestelling is voltooid',
        'de': 'Ihre Bestellung ist abgeschlossen'
    },
    'discount': {
        'en': 'Discount code',
        'fr': 'Code de réduction',
        'nl': 'Kortingscode',
        'de': 'Rabattcode'
    },
    'discount_amount': {
        'en': 'Discount amount',
        'fr': 'montant de la remise',
        'nl': 'Kortingsbedrag',
        'de': 'Rabattbetrag'
    },
    'discount_invalid_code': {
        'en': 'The discount code you entered is not (longer) valid.',
        'fr': "Le code de réduction que vous avez entré n'est (plus) valide.",
        'nl': 'De kortingscode die je ingaf is niet (meer) geldig.',
        'de': 'Der von Ihnen eingegebene Rabattcode ist nicht (mehr) gültig.'
    },
    'discount_max_reached': {
        'en': 'The maximum amount of the discount is ',
        'fr': "Le montant maximum de la réduction est ",
        'nl': 'Het maximum aantal korting bedraagt ',
        'de': 'Der maximale Rabattbetrag beträgt '
    },
    'discount_low_items': {
        'en': 'To take advantage of the discount, choose at least ',
        'fr': 'Pour profiter de la réduction, choisissez au moins ',
        'nl': 'Om gebruik te maken van de korting, kies minimaal ',
        'de': 'Um den Rabatt zu nutzen, wählen Sie mindestens '
    },
    'discount_min_price': {
        'en': 'To take advantage of the discount, order at least for ',
        'fr': 'Pour profiter de la réduction, commandez au minimum ',
        'nl': 'Om gebruik te maken van de korting, bestel voor minimum ',
        'de': 'Um den Rabatt zu nutzen, bestellen Sie mindestens '
    },
    'Delivery': {
        'en': 'Delivery',
        'nl': 'Leveren aan huis',
        'de': 'Hauslieferung',
        'fr': 'Livraison'
    },
    'DeliveryDistanceOutOfRange': {
        'en': 'The filled in address is too far for delivery',
        'nl': 'Het ingevoerde adres is te ver om te leveren',
        'de': 'Die eingegebene Adresse ist zu weit, um zu liefern',
        'fr': "l'adresse saisie est trop éloignée pour livrer"
    },
    'DeliveryCosts': {
        'en': 'Delivery costs',
        'nl': 'Leverkosten',
        'de': 'Versandkosten',
        'fr': 'Coûts de livraison'
    },
}